module.exports = __webpack_public_path__ + "static/media/nys_headshot.c6bb71bb.png";